module.exports = __webpack_public_path__ + "static/media/foto1.1931e708.png";